import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { handleTooltips } from 'utils/deprecated/ToolTipUtil';
import { hideModal } from './actions';

class ReactComponentWrapper extends React.Component {
    render() {
        let { store, children } = this.props;

        return (
            <Provider store={store}>
                <div>{children}</div>
            </Provider>
        );
    }

    componentDidMount() {
        handleTooltips();
    }

    componentDidUpdate() {
        handleTooltips();
    }

    componentWillUnmount() {
        const { dispatch } = this.props;

        if (dispatch) {
            dispatch(hideModal());
        }
    }
}

ReactComponentWrapper.propTypes = {
    store: PropTypes.object.isRequired
};

export default ReactComponentWrapper;
